if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();

        this.elements = {
          swiper: this.querySelector('[id^="Slider-Gallery"]')
        };

        if (!this.elements.swiper) return;

        this.swiper = null;
        this.lightbox = null;
        this.mobileMq = window.matchMedia('(max-width: 991px)');
        
        this.onBreakpointChange = this.handleSwiper.bind(this);
      }

      connectedCallback() {
        this.bindEvents();
        this.initPhotoSwipe();
        this.handleSwiper();
      }
      
      disconnectedCallback() {
        this.mobileMq.removeEventListener('change', this.onBreakpointChange);
        
        this.destroySwiper();
        
        if (this.lightbox) {
          this.lightbox.destroy();
          this.lightbox = null;
        }
      }

      bindEvents() {
        this.mobileMq.addEventListener('change', this.onBreakpointChange);
      }

      handleSwiper() {
        if (this.mobileMq.matches) {
          this.initSwiper();
        } else {
          this.destroySwiper();
        }
      }
      
      initSwiper() {
        if (this.swiper) return;

        this.swiper = new Swiper(this.elements.swiper, {
          slidesPerView: 1,
          spaceBetween: 12,
          autoplay: {
            delay: 6000,
            disableOnInteraction: false
          },
          pagination: {
            el: '.swiper-pagination'
          }
        });
      }
      
      async initPhotoSwipe() {
        if (this.lightbox) return;

        const { default: PhotoSwipeLightbox } = await import(window.photoswipeLightboxUrl);
        const { default: PhotoSwipe } = await import(window.photoswipeUrl);

        this.lightbox = new PhotoSwipeLightbox({
          gallery: this,
          children: 'a',
          pswpModule: PhotoSwipe,
        });

        this.lightbox.init();
      }
      
      destroySwiper() {
        if (!this.swiper) return;
        
        this.swiper.destroy(true, true);
        this.swiper = null;
      }
    }
  );
}